const getCurrency = (value, languageCode = 'en') => {
  const valueType = typeof value;

  if (valueType === 'number') {
    return value.toLocaleString(languageCode, {
      minimumFractionDigits: 2,
    });
  }

  throw Error('value must be number type');
};

export default getCurrency;
